/**
 * Meses (1-12) usados em formulários/listagens que trabalham com mês numérico,
 * como os temas mensais de DDS.
 */
export const MONTH_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const

export type MonthNumber = (typeof MONTH_NUMBERS)[number]

/**
 * Nome do mês no idioma atual, com a primeira letra maiúscula.
 * `month` é 1-based (1 = janeiro).
 */
export function getMonthLabel(month: number, locale = 'pt-BR'): string {
	// timeZone UTC é obrigatório: sem ele a data cai no mês anterior em fusos
	// negativos (ex.: UTC-3 exibiria "Dezembro" para o mês 1).
	const label = new Intl.DateTimeFormat(locale, {
		month: 'long',
		timeZone: 'UTC',
	}).format(new Date(Date.UTC(2000, month - 1, 1)))
	return label.charAt(0).toUpperCase() + label.slice(1)
}
